var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentilation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#78C081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20H2a2.002 2.002 0 0 1-2-2V2a2.002 2.002 0 0 1 2-2h16a2.002 2.002 0 0 1 2 2v16a2.002 2.002 0 0 1-2 2zm1.333-18c0-.736-.597-1.333-1.333-1.333H2C1.264.667.667 1.264.667 2v16c0 .736.597 1.333 1.333 1.333h16c.736 0 1.333-.597 1.333-1.333V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.333a1.167 1.167 0 1 1 0 2.334 1.167 1.167 0 0 1 0-2.334zM2.5 18a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM17.5 18.667a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zm0-1.667a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM2.5 3.667a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zM2.5 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM17.5 3.667a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334zM17.5 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM17.65 14.343l-.6 1a.67.67 0 0 1-.572.324H3.522a.67.67 0 0 1-.572-.324l-.6-1a.667.667 0 0 1 .572-1.01h14.156a.667.667 0 0 1 .572 1.01zM2.922 14l.6 1h12.956l.6-1H2.922zM17.65 11.343l-.6 1a.67.67 0 0 1-.572.324H3.522a.67.67 0 0 1-.572-.324l-.6-1a.667.667 0 0 1 .572-1.01h14.156a.667.667 0 0 1 .572 1.01zM2.922 11l.6 1h12.956l.6-1H2.922zM17.65 8.343l-.6 1a.67.67 0 0 1-.572.324H3.522a.67.67 0 0 1-.572-.324l-.6-1a.667.667 0 0 1 .572-1.01h14.156a.667.667 0 0 1 .572 1.01zM2.922 8l.6 1h12.956l.6-1H2.922zM17.05 6.343a.67.67 0 0 1-.572.324H3.522a.67.67 0 0 1-.572-.324l-.6-1a.667.667 0 0 1 .572-1.01h14.156a.667.667 0 0 1 .572 1.01l-.6 1zM2.921 5l.6 1h12.956l.6-1H2.922z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 20)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilation);
export default __webpack_public_path__ + "static/media/ventilation.18641284fbae25c434008d5a770322f0.svg";
export { ForwardRef as ReactComponent };